import { Switch } from 'react-router-dom'
import { Route } from '../core/components'
import { routesConfig } from '../core/configs/routes'
import { AuthRoutes } from './auth.routes'
import { UserRoutes } from './user.routes'

export const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" redirect={routesConfig.home} />
      <Route private path={routesConfig.userRoutes} component={UserRoutes} />
      <Route path={routesConfig.authRoutes} component={AuthRoutes} />
      <Route redirect={AuthRoutes} />
    </Switch>
  )
}
